import React, { Component } from "react";
import FormTitle from "../FormTitle/FormTitle";
import ReactGA from "react-ga";

import axios from "axios";
import FormBenefitsBox from "./FormBenefitsBox/FormBenefitsBox";
import classes from "./FormBenefits.module.scss";
import FormController from "../../components/FormController/FormController";
import * as ROUTES from "../../constants/routes";
import { withRouter } from "react-router-dom";
import { API_URL } from "../../config";

class FormBenefits extends Component {
  componentDidMount() {
    this.props.updateMultipleSelectedChoices({
      [ROUTES.PAGE_5_KEY]: "",
      selectYourSeatsUuid: "",
      buid: "",
      seatInfoSelected: "",
      numOfSeat: "",
    });
    if (this.props.formStart === "") {
      this.props.history.push("/");
    } else {
      if (window.adobeAnalytics) {
        window.adobeAnalytics.t({
          pageName:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Benefits",
        });
      }
    }
    ReactGA.pageview("/benefits");
    this.setState({
      exclusivity: this.props.benefits.exclusivity,
      savings: this.props.benefits.savings,
      convenience: this.props.benefits.convenience,
    });
    if (this.props.formStyle === "ballpark") {
      this.props.updateSelectedChoices(
        ROUTES.PAGE_3_KEY,
        ROUTES.PAGE_3_CHOICES_9
      );
    }
    let itemsSelected = [];
    if (Object.keys(this.props[ROUTES.PAGE_4_KEY]).length > 0) {
      this.props[ROUTES.PAGE_4_KEY].exclusivity.map((item) => {
        if (item.selected) {
          itemsSelected.push(item.label);
        }
        return false;
      });
      this.props[ROUTES.PAGE_4_KEY].savings.map((item) => {
        if (item.selected) {
          itemsSelected.push(item.label);
        }
        return false;
      });
      this.props[ROUTES.PAGE_4_KEY].convenience.map((item) => {
        if (item.selected) {
          itemsSelected.push(item.label);
        }
        return false;
      });
      this.setState({ benefits: itemsSelected });

      this.setState({
        [ROUTES.PAGE_4_BENEFIT_CAT_1]:
          this.props[ROUTES.PAGE_4_KEY][ROUTES.PAGE_4_BENEFIT_CAT_1],
        [ROUTES.PAGE_4_BENEFIT_CAT_2]:
          this.props[ROUTES.PAGE_4_KEY][ROUTES.PAGE_4_BENEFIT_CAT_2],
        [ROUTES.PAGE_4_BENEFIT_CAT_3]:
          this.props[ROUTES.PAGE_4_KEY][ROUTES.PAGE_4_BENEFIT_CAT_3],
        [ROUTES.PAGE_4_BENEFIT_CAT_4]:
          this.props[ROUTES.PAGE_4_KEY][ROUTES.PAGE_4_BENEFIT_CAT_4],
      });
    }
  }

  state = {
    benefits: [],
  };
  benefitsSubmitHandler = () => {
    axios
      .post(`${API_URL}/submitBenefits`, {
        benefits: this.state.benefits,
      })
      .then((response) => {
        this.props.updateSelectedChoices("buid", response.data.buid);
      })
      .then(() => this.props.history.push(ROUTES.PAGE_5_LINK))
      .catch((error) => {
        this.setState({ error: true });
      });
  };
  benefitsItemHandler = (category, label) => {
    const benefitExist = this.state.benefits.includes(label);
    if (window.adobeAnalytics && window.adobeAnalytics.tl) {
      window.adobeAnalytics.tl(
        true,
        "o",
        `Washington Nationals: Tickets: Nationals Ticketfinder: Benefits: ${category} : ${label} : ${
          benefitExist ? "deselect" : "select"
        } click`,
        {
          prop12: "Nationals TicketFinder",
          prop13:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Benefits",
          prop14: `${category} : ${label} : ${
            benefitExist ? "deselect" : "select"
          } click`,
        }
      );
    }
    if (benefitExist) {
      const _benefits = this.state.benefits;

      _benefits.splice(this.state.benefits.indexOf(label), 1);
      this.setState({ benefits: [..._benefits] });
    } else {
      this.setState({ benefits: [...this.state.benefits, label] });
    }

    this.setState(
      (prevState) => ({
        [category]: prevState[category].map((obj) =>
          obj.label === label
            ? Object.assign(obj, { selected: !obj.selected })
            : obj
        ),
      }),
      () => {
        this.props.updateSelectedChoices(ROUTES.PAGE_4_KEY, this.state);
      }
    );
  };

  render() {
    if (
      !this.state.exclusivity ||
      !this.state.savings ||
      !this.state.convenience
    ) {
      return <p>Loading ...</p>;
    }

    return (
      <div>
        <div>
          <FormTitle title="Select the benefits that interest you most" />
          {this.props[ROUTES.PAGE_3_KEY] !== "" ? (
            <>
              <div className={classes.FormBenefitsBoxWrapper}>
                <FormBenefitsBox
                  title="Exclusivity"
                  benefits={this.state[ROUTES.PAGE_4_BENEFIT_CAT_1]}
                  sizeOfPlan={this.props[ROUTES.PAGE_3_KEY]}
                  styleOfPlan={this.props[ROUTES.PAGE_2_KEY]}
                  benefitsItemHandler={this.benefitsItemHandler}
                  category={ROUTES.PAGE_4_BENEFIT_CAT_1}
                  cms={this.props.cms}
                />
                <FormBenefitsBox
                  title="Savings"
                  benefits={this.state[ROUTES.PAGE_4_BENEFIT_CAT_2]}
                  sizeOfPlan={this.props[ROUTES.PAGE_3_KEY]}
                  styleOfPlan={this.props[ROUTES.PAGE_2_KEY]}
                  benefitsItemHandler={this.benefitsItemHandler}
                  category={ROUTES.PAGE_4_BENEFIT_CAT_2}
                  cms={this.props.cms}
                />
                <FormBenefitsBox
                  title="Convenience"
                  benefits={this.state[ROUTES.PAGE_4_BENEFIT_CAT_3]}
                  sizeOfPlan={this.props[ROUTES.PAGE_3_KEY]}
                  styleOfPlan={this.props[ROUTES.PAGE_2_KEY]}
                  benefitsItemHandler={this.benefitsItemHandler}
                  category={ROUTES.PAGE_4_BENEFIT_CAT_3}
                  cms={this.props.cms}
                />
              </div>
              <FormController
                backTo={ROUTES.PAGE_3_LINK}
                nextTo={ROUTES.PAGE_5_LINK}
                startOver={ROUTES.PAGE_1_LINK}
                showBack={true}
                showStartOver={true}
                showSkip={true}
                showSubmit={true}
                disableSubmit={this.state.benefits.length <= 0}
                onSubmit={this.benefitsSubmitHandler}
              />
            </>
          ) : (
            <div className={classes.errorMsg}>Please choose a package</div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(FormBenefits);
